import { createContext, useContext, type ReactNode } from 'react';
import type { UndoStackAPI } from '../types';
import { useUndoStack } from '../hooks/useUndoStack';

const UndoContext = createContext<UndoStackAPI | null>(null);

/** Provider, создающий undo-стек и прокидывающий его через контекст. */
export function UndoProvider({ children }: { children: ReactNode }) {
  const undoStack = useUndoStack();
  return <UndoContext.Provider value={undoStack}>{children}</UndoContext.Provider>;
}

/** Hook для доступа к UndoStackAPI из контекста. */
export function useUndoContext(): UndoStackAPI {
  const ctx = useContext(UndoContext);
  if (!ctx) {
    throw new Error('useUndoContext must be used within an UndoProvider');
  }
  return ctx;
}
